import axios from "axios";
import Rest from "@/uptk/core/api/Rest";
import { buildSaasHeaders, resolveSaasContext } from "@/uptk/core/api/saasContext";
import type { ModuleRegistry } from "./types";

type ApiOptions = {
  tenantId?: string;
};

const buildHeaders = ({ tenantId }: ApiOptions) => {
  const saasContext = resolveSaasContext({ tenantId });
  return buildSaasHeaders(saasContext);
};

const buildUrl = (path: string) => Rest.getUrl(`/api${path}`);

export async function fetchModuleRegistry(options: ApiOptions): Promise<ModuleRegistry> {
  const response = await axios.get<ModuleRegistry>(buildUrl("/modules/registry"), {
    headers: buildHeaders(options),
  });
  return response.data;
}

export async function saveModuleRegistry(options: ApiOptions, registry: ModuleRegistry) {
  await axios.put(buildUrl("/modules/registry"), registry, {
    headers: buildHeaders(options),
  });
}
